import { format, utcToZonedTime } from "date-fns-tz";

export const parseValidDate = (value) => {
  if (value == null || value === "") {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const raw = String(value).trim();
  const candidates = [raw, raw.replace(" ", "T"), raw.replace(/-/g, "/")];

  for (const candidate of candidates) {
    const date = new Date(candidate);

    if (!Number.isNaN(date.getTime())) {
      return date;
    }
  }

  return null;
};

export const formatDate = (
  date = new Date(),
  dateFormat = "yyyy-MM-dd",
  timeZone = "Asia/Seoul",
) => {
  const parsed = parseValidDate(date);

  if (!parsed) {
    return "";
  }

  return format(parsed, dateFormat, {
    timeZone,
  });
};

export const getDateByTimeZone = (
  date = new Date(),
  timeZone = "Asia/Seoul",
) => {
  const parsed = parseValidDate(date);

  if (!parsed) {
    return null;
  }

  return utcToZonedTime(parsed, timeZone);
};
